import styled from "@emotion/styled"
import { ButtonProps } from "@mui/material";
import { Search24Icon } from '@kep-ui-kit/ui-icons';

const StyledButton = styled('button')(() => ({
    padding: '0 8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '8px',
    cursor: 'pointer',
}));

export const BeSearchButton = (props: ButtonProps) => (
    <StyledButton {...props} type="button">
        <Search24Icon />
    </StyledButton>
);
